import styled from "styled-components";
import { FlexRow } from "styles/layout";
import { Theme } from "theme";

export const MatchContainer = styled(FlexRow)`
  padding: 4px ${Theme.smallPanelPadding};
  line-height: 100%;
`;
